import { cn } from '../../lib/utils';

const MAX_WIDTH = {
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
};

/**
 * Standard shell for authenticated full pages under AppLayout.
 * Matches Coaching skills / training plan design: centered column, px-4/md:px-6, py-6, pb-16.
 */
export default function AppPageShell({ children, className, maxWidth = '6xl' }) {
  return (
    <div
      className={cn(
        'mx-auto w-full space-y-6 px-4 py-6 pb-16 md:px-6',
        MAX_WIDTH[maxWidth] || MAX_WIDTH['6xl'],
        className
      )}
    >
      {children}
    </div>
  );
}
